export default __webpack_public_path__ + "static/media/frontend.2984c07f.gif";